import { render, staticRenderFns } from "./FormColorInput.vue?vue&type=template&id=50276e8a&scoped=true&"
import script from "./FormColorInput.vue?vue&type=script&lang=js&"
export * from "./FormColorInput.vue?vue&type=script&lang=js&"
import style0 from "./FormColorInput.vue?vue&type=style&index=0&id=50276e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50276e8a",
  null
  
)

export default component.exports